import React from 'react';

interface Props {
  value: string | number;
}
function BooleanFormatter({ value }: Props) {
  return <span>{value ? 'Ja' : 'Nein'}</span>;
}

export default BooleanFormatter;
